import React, { Component  } from "react"
import Select from "../../../../components/Select"
import cfg from "../../../../utils/config"
import auth from "../../../../utils/auth"
import ButtonsForm from "../../../../components/ButtonsForm"
import axios from "axios"
import helper from "../../../../utils/helper"
import { Link, Redirect } from "react-router-dom"
import { components } from "react-select"

class FormDevice extends Component {
    userInfo = auth.getUserInfo()

    state = { 
        detalhes: {
            name: null,
            description: null,
            dev_eui: null,
            join_eui: null,
            device_profile_id: null,
            otaa_keys: null,
            is_disabled: false,
            skip_fcnt_check: false,
            dev_addr: null,
            app_s_key: null,
            nwk_s_enc_key: null,
            f_cnt_up: 0,
            n_f_cnt_down: 0,
            redirection: null,
            access: null
        },
        cooldown: false,
        redirect: false,
        path: "",
        optionsProfiles: [],
        selectedDeviceProfileSupportsOtaa: true,
        redirectionOptions: [],
        optionsAcesso: [],
    }

    get applicationId() {
        if (this.props.isQuickRegister && this.props.applicationId) {
            return this.props.applicationId;
        }

        return this.props?.match?.params?.id;
    }

    get clienteApplicationId() {
        if (this.props.isQuickRegister && this.props.clienteApplicationId) {
            return this.props.clienteApplicationId;
        }

        return this.props?.match?.params?.idCliente ?? false;
    }

    get deviceId() {
        if (this.props.isQuickRegister && this.props.deviceId) {
            return this.props.deviceId
        }

        return this.props?.match?.params?.idDevice
    }

    componentDidMount = async () => {
        await this.getDeviceProfiles()
        await this.getRedirections()
        await this.getTipoAcessos()

        if (this.deviceId) {
            this.getData()
        }
    }

    getDeviceProfiles = async () => {
        let url = cfg.base_api_url + cfg.api_v2 + '/' + this.userInfo.empresa + '/lns/device/profile/'

        if(this.clienteApplicationId) {
            url = cfg.base_api_url + cfg.api_v2 + '/' + this.userInfo.empresa + `/lns/device/profile/?cliente=${this.clienteApplicationId}`
        }

        let config_me = { headers: { 'Authorization': 'Bearer ' + auth.getToken() } }

        return axios.get(url, config_me)
            .then(({ data }) => {
                const optionsSelect = []

                data.results.forEach((item) => {
                    optionsSelect.push({
                        label: item.name,
                        value: item.id,
                        extra_fields: item.extra_fields
                    })
                })

                const newState = { optionsProfiles: optionsSelect }

                if (this.props.isQuickRegister && this.props.deviceProfileId) {
                    const selectedProfile = optionsSelect.find(item => item.value == this.props.deviceProfileId)

                    if (selectedProfile) {
                        newState.detalhes = {
                            ...this.state.detalhes,
                            device_profile_id: selectedProfile
                        }

                        newState.selectedDeviceProfileSupportsOtaa = !!selectedProfile?.extra_fields?.supports_otaa
                    }
                }

                this.setState(newState)
            })
    }

    getData = () => {
        const requestURL = cfg.base_api_url + cfg.api_v2 + '/' + this.userInfo.empresa + '/lns/application/' + this.applicationId + '/device/' + this.deviceId + '/'
        let config_me = { headers: { 'Authorization': 'Bearer ' + auth.getToken() } }

        axios.get(requestURL, config_me).then(({ data }) => {
            const optionsProfiles = this.state.optionsProfiles

            const detalhes = { 
                name: data.name, 
                description: data.description, 
                dev_eui: data.dev_eui, 
                join_eui: data.join_eui, 
                device_profile_id: optionsProfiles.find((item) => item.value == data.device_profile_id) ?? null, 
                otaa_keys: data.otaa_keys, 
                is_disabled: data.is_disabled, 
                skip_fcnt_check: data.skip_fcnt_check,
                dev_addr: data.dev_addr,
                app_s_key: data.app_s_key,
                nwk_s_enc_key: data.nwk_s_enc_key,
                f_cnt_up: data.f_cnt_up ?? 0,
                n_f_cnt_down: data.n_f_cnt_down ?? 0,
                redirection: data?.redirecionamento?.id ?? null,
                access: data?.acesso?.id ?? null,
            }

            this.setState({ detalhes, selectedDeviceProfileSupportsOtaa: optionsProfiles.find(profile => profile.value == data.device_profile_id)?.extra_fields?.supports_otaa })
        })
    }

    handleChange = (field, value) => {
        const detalhes = { ...this.state.detalhes }
        const span = document.getElementById(`validacao-${field}`)
        if (span) span.innerHTML = ""

        detalhes[field] = value

        if(field === 'redirection' && !value) {
            detalhes['access'] = null
            this.setState({detalhes})
        }

        let currentProfileId
        if (field === "device_profile_id") {
            currentProfileId = value?.value ?? value
            const perfil = this.state.optionsProfiles.find(
                profile => profile.value === currentProfileId
            )
    
            let selectedDeviceProfileSupportsOtaa = !!(perfil && perfil.extra_fields && perfil.extra_fields.supports_otaa)
            
            this.setState({ selectedDeviceProfileSupportsOtaa })
        } else {
            currentProfileId = detalhes.device_profile_id?.value ?? detalhes.device_profile_id
        }

        this.setState({ detalhes })
    }

    handleQuickRegister = async () => {
        return new Promise((resolve) => {
            if (!this.state.detalhes.name) {
                helper.dispatchEvent("showAviso", {
                    message: "Nenhum dado preenchido, deseja prosseguir sem adicionar um dispositivo?",
                    callback: () => resolve({ success: true }),
                    callbackClose: () => {
                        resolve({ success: false })
                    },
                    callbackLabelClose: "Não"
                });

                return;
            }

            this.saveAction(false, resolve);
        });
    };

    saveAction = (novoCadastro, resolve = null) => {
        const { detalhes } = this.state

        this.setState({ cooldown: true })

        let requestURL = ""
        let verb = ""

        if (this.deviceId) {
            requestURL = cfg.base_api_url + cfg.api_v2 + '/' + this.userInfo.empresa + '/lns/application/' + this.applicationId + '/device/' + this.deviceId + '/'
            verb = 'patch'
        } else {
            requestURL = cfg.base_api_url + cfg.api_v2 + '/' + this.userInfo.empresa + '/lns/application/' + this.applicationId + '/device/'
            verb = 'post'
        }

        const data = {}

        data["name"] = detalhes.name ?? ""
        data["description"] = detalhes.description ?? ""
        data["dev_eui"] = detalhes.dev_eui ?? ""
        data["join_eui"] = detalhes.join_eui ?? ""
        data["device_profile_id"] = detalhes.device_profile_id?.value ?? ""
        data["is_disabled"] = detalhes.is_disabled
        data["skip_fcnt_check"] = detalhes.skip_fcnt_check
        if ( this.state.selectedDeviceProfileSupportsOtaa ) {
            data["otaa_keys"] = detalhes.otaa_keys ?? ""
        } else {
            data["dev_addr"] = detalhes.dev_addr ?? ""
            data["app_s_key"] = detalhes.app_s_key ?? ""
            data["nwk_s_enc_key"] = detalhes.nwk_s_enc_key ?? ""
            data["f_cnt_up"] = detalhes.f_cnt_up ?? 0
            data["n_f_cnt_down"] = detalhes.n_f_cnt_down ?? 0
        }

        if (!this.props.isQuickRegister) {
            data["redirecionamento_id"] = detalhes?.redirection ?? null
            data["acesso_id"] = detalhes?.access ?? null
        }

        axios({
            method: verb,
            url: requestURL,
            data: data,
            headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + auth.getToken() }
        }).then((res) => {
            if (novoCadastro) {
                window.location.reload()
            } else {
                const mensagemErrosDispositivos = helper.formatarDispositivosErros(res.data?.dispositivos_erros)
                const mensagemBase = `Dispositivo ${verb === "post" ? "criado" : "editado"} com sucesso.`
                const mensagem = mensagemErrosDispositivos
                    ? `${mensagemBase}<br/><br/>Porém, o vínculo com o redirecionamento falhou:<br/>${mensagemErrosDispositivos}`
                    : mensagemBase

                helper.dispatchEvent("showAviso", {
                    message: mensagem,
                    callback: () => {
                        if (this.props.isQuickRegister) {
                            if (resolve) {
                                resolve({
                                    success: true,
                                    deviceId: res.data.id,
                                })
                            }

                            return
                        }
                        this.setState({ redirect: true, path: `/lns/application/${this.applicationId}/editar/1` })
                    },
                    callbackClose: () => {
                        if (this.props.isQuickRegister) {
                            if (resolve) {
                                resolve({
                                    success: true,
                                    deviceId: res.data.id,
                                })
                            }

                            return
                        }
                        if (verb === "post") {
                            window.location.href = `/lns/application/${this.applicationId}/device/${res.data.id}/editar`
                            setTimeout(() => { window.location.reload() }, 1000)
                        }
                    }
                })
            }
        }).catch((error) => {
            if (resolve) {
                resolve({
                    success: false,
                })
            }

            if (typeof error.response?.data === "string") {
                helper.dispatchEvent("showAviso", {
                    message: error.response.data
                })

                return
            }

            if (error.response?.data?.detail) {
                helper.dispatchEvent("showAviso", {
                    message: error.response.data.detail
                })

                return
            }

            let erros = Object.entries(error.response?.data || {})

            if (Array.isArray(erros)) {
                for (let i = 0; i < erros.length; i++) {
                    let span = document.querySelector(`#validacao-${erros[i][0]}`)
                    if (span) span.innerHTML = erros[i][1]
                }
            }
        }).finally(() => {
            this.setState({ cooldown: false })
        })
    }

    getRedirections = async () => {
        this.setState({ loading: true })
        let config_me = { headers: { 'Authorization': 'Bearer ' + auth.getToken() } }
        let userInfo = auth.getUserInfo()
        let url = cfg.base_api_url + cfg.api_v2 + '/' + userInfo.empresa + '/lns/redirecionamentos/?limit='

        axios.get(url, config_me).then((res) => {
            this.setState({
                redirectionOptions: (res.data?.results || []).map((item) => ({
                    label: item.nome,
                    value: item.id,
                    type: item.tipo
                })),
            });
        });
    }

    getTipoAcessos = () => {
        let config_me = { headers: { 'Authorization': 'Bearer ' + auth.getToken() } }

        axios.get(cfg.base_api_url + cfg.api_v2 + '/' + this.userInfo.empresa + "/acesso/?meus_acessos=true", config_me).then(({ data }) => {
            const totalDeAcessos = data.total
            const acessosUtilizados = data.utilizados

            let optionsAcesso = totalDeAcessos.map((item) => {
                let acessoContido = acessosUtilizados.find((acesso) => item.acesso_tipo == acesso.acesso_tipo)
                let isDisabled = false
                let disponiveis = item.tcount

                if (acessoContido) {
                    disponiveis = item.tcount - acessoContido.tcount
                    isDisabled = disponiveis == 0
                }

                return { label: item.acesso_tipo__descricao, value: item.acesso_tipo, isDisabled, acessosDisponiveis: disponiveis }
            })

            this.setState({ optionsAcesso })
        })
    }

    showInfo = (info, callback = null) => {
        helper.dispatchEvent("showAviso", {
            message: info,
            callback: callback,
        })
    }

    render() {
        const { detalhes, optionsProfiles, redirectionOptions, optionsAcesso } = this.state
        const edit = this.deviceId ? true : false
        const selectedRedirection = redirectionOptions.find(item => item.value == detalhes?.redirection)
        const redirectionType = selectedRedirection?.type ?? null

        const { Option } = components
        const IconOption = (props) => {
            const disabled = props?.data?.isDisabled
            return (
                <Option {...props}>
                    <span className="d-flex align-items-center">
                        <i style={{ fontSize: '16px', color: disabled ? "#cf2b2b" : '#2bb33f', borderRadius: "8px" }} className="fa fa-square mr-1"></i>
                        <b style={{ color: '#222', fontWeight: 'normal', opacity: disabled ? 0.7 : 1 }}>{props?.data?.label} Disponíveis = {props?.data?.acessosDisponiveis}</b>
                    </span>
                </Option>
            )
        }

        if (this.state.redirect) {
            return <Redirect to={this.state.path} />
        }
        
        return (
           <div>
                <div className="hdv-default-header mx-3">
                    <span className="screen-menu-desc">
                        <i
                            className="fa fa-info-circle fa-20px"
                            title='Informações do Cadastro de Dispositivos'
                            style={{ cursor: "pointer", marginTop: '8px', marginRight: '5px' }}
                            onClick={() =>
                                helper.dispatchEvent("showAviso", {
                                    message: `Aqui você vincula o dispositivo físico já configurado em campo à nossa rede. Utilize as chaves correspondentes ao método de autenticação definido no perfil (OTAA ou ABP). `,
                                })
                            }
                        />
                        {edit ? <h4>Editar Dispositivo</h4> : <h4>Novo Dispositivo</h4>}
                        <div className="gray-background">
                            <i className="las la-hdd la-2x"></i> 
                        </div>
                    </span>
                </div>

                <div className="hdv-form-default">
                    <div className="row">
                        <div className="col-md-6">
                            <label className='required' htmlFor="name">Nome</label>
                            <input
                                type='text'
                                value={detalhes.name ?? ""}
                                id="name"
                                onChange={(e) => this.handleChange("name", e.target.value)}
                            />
                            <span id='validacao-name'></span>
                        </div>
                        <div className="col-md-6">
                            <label className='required' htmlFor="description">Descrição</label>
                            <input
                                type='text'
                                value={detalhes.description ?? ""}
                                id="description"
                                onChange={(e) => this.handleChange("description", e.target.value)}
                            />
                            <span id='validacao-description'></span>
                        </div>
                    </div>
                    
                    <div className="row">
                        <div className="col-md-6">
                            <label className='required' htmlFor="dev_eui">Dispositivo EUI (EUI64)</label>
                            <input
                                type='text'
                                value={detalhes.dev_eui ?? ""}
                                id="dev_eui"
                                onChange={(e) => this.handleChange("dev_eui", e.target.value)}
                                disabled={edit}
                            />
                            <span id='validacao-dev_eui'></span>
                        </div>
                        <div className="col-md-6">
                            <label className='required' htmlFor="join_eui">EUI de Entrada (EUI64)</label>
                            <input
                                type='text'
                                value={detalhes.join_eui ?? ""}
                                id="join_eui"
                                onChange={(e) => this.handleChange("join_eui", e.target.value)}
                            />
                            <span id='validacao-join_eui'></span>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-12">
                            <label className="required" htmlFor="device_profile_id">Perfil do Dispositivo</label>
                            <Select
                                value={detalhes.device_profile_id}
                                options={optionsProfiles}
                                onChange={(e) => this.handleChange("device_profile_id", e)}
                            />
                            <span id='validacao-device_profile_id'></span>
                        </div>
                    </div>

                    {(this.state.selectedDeviceProfileSupportsOtaa || !detalhes.device_profile_id) ? (
                        <div className="row">
                            <div className="col-md-12">
                                <label className="required" htmlFor="otaa_keys">Chaves OTAA (APP KEY ou NWK KEY)</label>
                                <input
                                    type='text'
                                    value={detalhes.otaa_keys ?? ""}
                                    id="otaa_keys"
                                    onChange={(e) => this.handleChange("otaa_keys", e.target.value)}
                                />
                                <span id='validacao-otaa_keys'></span>
                            </div>
                        </div>
                    ) : (
                        <>
                            <div className="row">
                                <div className="col-md-4">
                                    <label className="required" htmlFor="otaa_keys">Endereço do Dispositivo</label>
                                    <input
                                        type='text'
                                        value={detalhes.dev_addr ?? ""}
                                        id="dev_addr"
                                        onChange={(e) => this.handleChange("dev_addr", e.target.value)}
                                    />
                                    <span id='validacao-dev_addr'></span>
                                </div>
                                <div className="col-md-4">
                                    <label className="required" htmlFor="app_s_key">Chave da Sessão de Aplicação (LoRaWAN 1.0)</label>
                                    <input
                                        type='text'
                                        value={detalhes.app_s_key ?? ""}
                                        id="app_s_key"
                                        onChange={(e) => this.handleChange("app_s_key", e.target.value)}
                                    />
                                    <span id='validacao-app_s_key'></span>
                                </div>
                                <div className="col-md-4">
                                    <label className="required" htmlFor="nwk_s_enc_key">Chave da Sessão de Rede (LoRaWAN 1.0)</label>
                                    <input
                                        type='text'
                                        value={detalhes.nwk_s_enc_key ?? ""}
                                        id="nwk_s_enc_key"
                                        onChange={(e) => this.handleChange("nwk_s_enc_key", e.target.value)}
                                    />
                                    <span id='validacao-nwk_s_enc_key'></span>
                                </div>
                            </div>                            
                            <div className="row">
                                <div className="col-md-6">
                                    <label className="required" htmlFor="f_cnt_up">Uplink Contador de Quadros</label>
                                    <input
                                        type='number'
                                        value={detalhes.f_cnt_up ?? 0}
                                        id="f_cnt_up"
                                        onChange={(e) => this.handleChange("f_cnt_up", e.target.value)}
                                    />
                                    <span id='validacao-f_cnt_up'></span>
                                </div>
                                <div className="col-md-6">
                                    <label className="required" htmlFor="n_f_cnt_down">Downlink Contador de Quadros</label>
                                    <input
                                        type='number'
                                        value={detalhes.n_f_cnt_down ?? 0}
                                        id="n_f_cnt_down"
                                        onChange={(e) => this.handleChange("n_f_cnt_down", e.target.value)}
                                    />
                                    <span id='validacao-n_f_cnt_down'></span>
                                </div>
                            </div>
                        </> 
                    )}

                    <div className="row">
                        <div className="col-md-6">
                            <label className='required' htmlFor="is_disabled">O dispositivo está desabilitado</label>
                            <input
                                type='checkbox'
                                checked={detalhes.is_disabled}
                                id="is_disabled"
                                onChange={(e) => this.handleChange("is_disabled", e.target.checked)}
                            />
                            <span id='validacao-is_disabled'></span>
                        </div>
                        <div className="col-md-6">
                            <label className='required' htmlFor="skip_fcnt_check">Desabilitar validação do contador de quadros</label>
                            <input
                                type='checkbox'
                                checked={detalhes.skip_fcnt_check}
                                id="skip_fcnt_check"
                                onChange={(e) => this.handleChange("skip_fcnt_check", e.target.checked)}
                            />
                            <span id='validacao-skip_fcnt_check'></span>
                        </div>
                    </div>

                    {!this.props.isQuickRegister &&
                        <div className="row">
                            <div className="col-md-6">
                                <label className="required" htmlFor="redirection">
                                    <i
                                        className="fa fa-info-circle"
                                        title={"Informações sobre o vínculo de redirecionamento"}
                                        style={{ cursor: "pointer" }}
                                        onClick={() => this.showInfo(
                                            `
                                                O vínculo do dispositivo a um redirecionamento é opcional. </br></br>
                                                Remover o redirecionamento ou o acesso selecionado e salvar irá remover o vínculo do dispositivo com os mesmos.
                                            `
                                        )}
                                    />
                                    &nbsp;
                                    Redirecionamento
                                </label>
                                <Select
                                    value={detalhes?.redirection}
                                    options={redirectionOptions}
                                    onChange={(e) => this.handleChange("redirection", e?.value ?? null)}
                                    resolveValueFromOptions
                                    disabled={!redirectionOptions.length}
                                    isClearable
                                />
                                <span id='validacao-redirection'></span>
                            </div>
                            <div className="col-md-6">
                                <label className='required'>
                                    <i
                                        className="fa fa-info-circle"
                                        title={"Informações sobre o acesso"}
                                        style={{ cursor: "pointer" }}
                                        onClick={() => this.showInfo("A seleção de acesso só é liberada se o redirecionamento selecionado for do tipo interno.")}
                                    />
                                    &nbsp;
                                    Acesso
                                </label>
                                <Select
                                    components={{ Option: IconOption }}
                                    value={detalhes?.access}
                                    options={optionsAcesso}
                                    onChange={(e) => this.handleChange("access", e?.value ?? null)}
                                    resolveValueFromOptions
                                    disabled={!optionsAcesso.length || redirectionType != "interno"}
                                    isClearable
                                />
                            </div>
                        </div>
                    }
                </div>

                {!this.props.isQuickRegister &&
                    <div className="hdv-btn-group">
                        <ButtonsForm
                            route="/device"
                            edit={edit ? true : false}
                            cooldown={this.state.cooldown}
                            buttons={[
                                {
                                    method: "post",
                                    button: <button onClick={() => this.saveAction(false)} className="hdv-btn-forms hdv-btn-green" disabled={this.cooldown}>Salvar</button>
                                },

                                {
                                    method: "post",
                                    button: <button style={{ display: edit ? "none" : "inline-block" }} onClick={() => this.saveAction(true)} className="hdv-btn-forms hdv-btn-greenlight" disabled={this.cooldown}>Salvar e Cadastrar um Novo</button>
                                },

                                {
                                    method: "patch",
                                    button: <button onClick={() => this.saveAction(false)} className="hdv-btn-forms hdv-btn-green" disabled={this.cooldown}>Salvar</button>
                                },
                            ]}
                        />
                        <Link to={`/lns/application/${this.applicationId}/editar/1`}>
                            <button className="hdv-btn-forms hdv-btn-orange">Cancelar</button>
                        </Link>
                    </div>
                }
           </div>
        )
    }
}

export default FormDevice